import { runAsyncWithTimeMeasurement } from './runAsyncWithTimeMeasurement';

export type RunAsyncUntilCompleteResult<T> =
  | { type: 'not-completed' }
  | { type: 'completed'; data: T };

export type RunAsyncUntilCompleteOptions = {
  timeout: number;
};

export function runAsyncUntilComplete<T>(
  fn: () => Promise<RunAsyncUntilCompleteResult<T>>,
  options: RunAsyncUntilCompleteOptions = { timeout: 240000 }
): Promise<T> {
  let remainingTimeout = options.timeout;

  const runUntilComplete = async (): Promise<T> => {
    const { response, deltaTime } = await runAsyncWithTimeMeasurement(fn);

    if (response.type === 'completed') return response.data;

    remainingTimeout -= deltaTime;
    if (remainingTimeout <= 0) throw new Error('Request timed out');

    return runUntilComplete();
  };

  return runUntilComplete();
}
